module.exports = __webpack_public_path__ + "img/jd2_jixw_ic2.d4c6c8e7.png";